import { render, staticRenderFns } from "./FormOrganization.vue?vue&type=template&id=681bbba2"
import script from "./FormOrganization.vue?vue&type=script&lang=ts"
export * from "./FormOrganization.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports